/**
 * SOLFIE — Sugestões de produto na PDP (seção "Combina com").
 *
 * O Liquid já renderiza uma lista de fallback (metafield → coleção → coleção do
 * produto). Este script pede as recomendações reais da Shopify
 * (/recommendations/products.json) e, se elas vierem, troca os cards por
 * produtos realmente relacionados.
 *
 * Configuração vem de data-attributes na própria seção:
 *   data-recomendar   "true"/"false"
 *   data-product-id   id do produto atual
 *   data-limit        quantidade de cards
 *   data-intent       "related" | "complementary"
 *   data-add-text     rótulo do botão de adicionar
 */
(function () {
  'use strict';

  function escapar(txt) {
    return String(txt == null ? '' : txt).replace(/[&<>"']/g, function (c) {
      var mapa = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
      return mapa[c];
    });
  }

  function dinheiro(centavos, locale, moeda) {
    try {
      return (centavos / 100).toLocaleString(locale, { style: 'currency', currency: moeda });
    } catch (e) {
      return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
    }
  }

  function comLargura(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=400';
  }

  function montarCard(produto, textoAdd, locale, moeda) {
    var variantes = produto.variants || [];
    var variante = null;
    for (var i = 0; i < variantes.length; i++) {
      if (variantes[i].available) { variante = variantes[i]; break; }
    }
    if (!variante && variantes.length) variante = variantes[0];

    var disponivel = !!produto.available && !!variante;
    var preco = variante ? variante.price : produto.price;
    var comparar = variante ? variante.compare_at_price : produto.compare_at_price;
    var temDesconto = comparar && comparar > preco;

    var badge = '';
    if (!disponivel) {
      badge = '<span class="solfie-pairs__badge">Esgotado</span>';
    } else if (temDesconto) {
      badge = '<span class="solfie-pairs__badge solfie-pairs__badge--sale">-' +
        Math.round((comparar - preco) * 100 / comparar) + '%</span>';
    }

    var capa = comLargura(produto.featured_image || (produto.images || [])[0]);
    var titulo = escapar(produto.title);

    var media = capa
      ? '<img class="solfie-pairs__img" src="' + capa + '" alt="' + titulo +
        '" loading="lazy" decoding="async" width="400" height="500">'
      : '<span class="solfie-pairs__ph"></span>';

    var precoHtml = (temDesconto
      ? '<span class="solfie-pairs__price-compare">' + escapar(dinheiro(comparar, locale, moeda)) + '</span>'
      : '') +
      '<span class="solfie-pairs__price-now">' + escapar(dinheiro(preco, locale, moeda)) + '</span>';

    return '<article class="solfie-pairs__card" data-product-id="' + produto.id + '">' +
      '<a class="solfie-pairs__media" href="' + produto.url + '" aria-label="' + titulo + '">' +
      media + badge +
      '</a>' +
      '<div class="solfie-pairs__info">' +
      '<a class="solfie-pairs__name" href="' + produto.url + '">' + titulo + '</a>' +
      '<p class="solfie-pairs__price">' + precoHtml + '</p>' +
      '<button type="button" class="solfie-pairs__add" data-role="add" data-variant-id="' +
      (variante ? variante.id : '') + '"' + (disponivel ? '' : ' disabled') + '>' +
      (disponivel ? escapar(textoAdd) : 'Esgotado') +
      '</button>' +
      '</div>' +
      '</article>';
  }


  function adicionar(btn, original) {
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add falhou'); return r.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        btn.textContent = 'Adicionado ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.textContent = original;
        }, 2400);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        btn.textContent = 'Erro, tentar de novo';
        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.textContent = original;
        }, 2600);
      });
  }


  function iniciar(root) {
    if (!root || root.dataset.recInit) return;
    root.dataset.recInit = '1';
    if (root.dataset.recomendar !== 'true') return;

    var lista = root.querySelector('[data-role="list"]');
    var produtoId = root.dataset.productId;
    if (!lista || !produtoId) return;

    var limite = parseInt(root.dataset.limit, 10) || 4;
    var intencao = root.dataset.intent || 'related';
    var textoAdd = root.dataset.addText || 'Adicionar';
    var moeda = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
    var locale = document.documentElement.lang || 'pt-BR';

    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(produtoId) +
      '&limit=' + limite + '&intent=' + encodeURIComponent(intencao);

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (dados) {
        if (!dados || !dados.products || !dados.products.length) return;

        var filtrados = dados.products.filter(function (p) {
          return String(p.id) !== String(produtoId);
        });
        if (!filtrados.length) return;

        lista.innerHTML = filtrados.slice(0, limite).map(function (p) {
          return montarCard(p, textoAdd, locale, moeda);
        }).join('');

        lista.querySelectorAll('[data-role="add"]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            adicionar(btn, textoAdd);
          });
        });
      })
      .catch(function () {});
  }


  function iniciarTodos() {
    document.querySelectorAll('.solfie-pairs[data-recomendar]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', iniciarTodos);
})();
